import { useEffect, useState } from 'react';

// Site-wide light/dark toggle. Reads/writes the same `data-theme` attribute
// and `em-theme` localStorage key the inline bootstrap script in
// public/index.html uses, so every instance of this button stays in sync
// and there's no flash of the wrong theme on load.
const ThemeToggle = ({ className = '', style }) => {
  const [dark, setDark] = useState(true);

  useEffect(() => {
    const root = document.documentElement;
    const isDark = () => {
      const t = root.getAttribute('data-theme');
      return t ? t === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    };
    setDark(isDark());
  }, []);

  const toggle = () => {
    const root = document.documentElement;
    const next = dark ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('em-theme', next); } catch (e) { /* ignore */ }
    setDark(!dark);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={className}
      style={{
        width: 34, height: 34, borderRadius: '50%', border: '1.5px solid currentColor',
        background: 'transparent', color: 'currentColor', display: 'grid', placeItems: 'center',
        cursor: 'pointer', padding: 0, flexShrink: 0, transition: 'color .2s',
        ...style,
      }}
    >
      {dark ? (
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4.2" />
          <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
          <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
